module.exports = __webpack_public_path__ + "static/assets/b3bb6bf5e17cd307b3f50d76fe4b7d62.png";